
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "payments-ui-app",
  currentProjectVersion: "static-1.28721",
  depVersions: {
  "payments-ui-app": "static-1.28721",
  "bend-plugin-arboretum": "static-1.2025",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.511",
  "crm_data": "static-4.93224",
  "data-fetching-client": "static-1.10122",
  "emoji-mart": "static-3.7",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8761",
  "foundations-components-legacy": "static-1.1786",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6074",
  "hs-test-utils": "static-1.8520",
  "hub-http": "static-1.6688",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11969",
  "I18n": "static-7.1708",
  "jasmine-runner": "static-1.6934",
  "quartz": "static-1.7665",
  "raven": "static-3.5925",
  "react-dlb": "static-1.94",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-stripe-js": "static-1.120",
  "react-utils": "static-2.5659",
  "reselect": "static-3.16",
  "stripe-js": "static-1.119",
  "ui-components-test-utils": "static-1.6106",
  "UIComponents": "static-3.8915",
  "usage-tracker-public": "static-1.7617",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38071",
  "payments-checkout-lib": "static-1.644",
  "cssUtils": "static-1.1104",
  "customer-data-objects": "static-1.8187",
  "FireAlarmUi": "static-1.4871",
  "foundations-assets": "static-1.5368",
  "foundations-theming": "static-1.4970",
  "graphql": "static-1.93",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12276",
  "icons": "static-2.703",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3366",
  "property-translator": "static-1.5861",
  "quartz-config": "static-1.1443",
  "quartz-core": "static-1.6884",
  "quartz-i18n": "static-1.1340",
  "quartz-routing": "static-1.1095",
  "quartz-tracking": "static-1.1044",
  "react": "static-7.203",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17219",
  "react-select-plus": "static-1.118",
  "react-virtualized": "static-2.112",
  "redux": "static-4.81",
  "redux-thunk": "static-2.84",
  "redux-toolkit": "static-1.82",
  "ReduxMessenger": "static-2.10852",
  "rpc-client-utils": "static-1.5151",
  "sanitize-text": "static-1.8640",
  "SharedI18nStrings": "static-1.188",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.518",
  "superstore": "static-1.5241",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11627",
  "ui-images": "static-2.1277",
  "usage-tracker-core": "static-1.7656",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3942",
  "quartz-webpack": "static-1.3889",
  "bend-plugin-quartz-routing": "static-1.743",
  "bender-build-tools": "static-1.3600",
  "crm_universal": "static-1.22738",
  "customer-data-email": "static-1.18653",
  "customer-data-ui-utilities": "static-1.10313",
  "dispatcher": "static-1.147",
  "frontend-preferences-client": "static-1.8402",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8245",
  "quick-fetch": "static-1.4234",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5030",
  "floating-ui": "static-1.68",
  "foundations-theming-specialty": "static-1.2686",
  "framer-motion": "static-1.84",
  "hs-story-utils": "static-1.9909",
  "react-aria": "static-1.77",
  "react-create-root-preference": "static-1.103",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3102",
  "ui-fonts": "static-1.1231",
  "HeadJS": "static-2.822",
  "hs-test-utils-bend-plugin": "static-1.3631",
  "msw": "static-1.103",
  "msw-config": "static-1.29",
  "testing-library": "static-1.164",
  "hs-locale-management": "static-1.403",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4789",
  "foundations-components-test-utils": "static-1.6244",
  "ui-addon-draggable": "static-3.5230",
  "commerce-billing-lib": "static-1.20509",
  "commerce-shared-components-lib": "static-1.19581",
  "commerce-tools-ui-lib": "static-1.11336",
  "crm-message-bus": "static-1.44127",
  "customer-data-objects-ui-components": "static-1.13517",
  "customer-data-properties": "static-1.53071",
  "growth-payments-core": "static-1.26520",
  "ui-addon-iframeable": "static-1.9557",
  "usage-tracker": "static-1.7806",
  "usage-tracker-container": "static-1.7796",
  "sassPrefix": "static-1.370",
  "inbound-db-properties-service-client": "static-1.4154",
  "foundations-theming-base": "static-1.3955",
  "bend-plugin-foundations-theming": "static-1.3453",
  "stylex": "static-1.46",
  "opentelemetry-fe-types": "static-1.273",
  "hub-http-janus": "static-1.907",
  "hubspotter-http": "static-1.4978",
  "mobile-manifest-mixins": "static-1.606",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.648",
  "quartz-auth": "static-1.1340",
  "quartz-head": "static-1.1330",
  "quartz-test": "static-1.1340",
  "trellis-components": "static-1.3121",
  "usage-tracker-session-replay": "static-1.5492",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.182",
  "web-vitals": "static-1.19",
  "immer": "static-1.105",
  "bend-plugin-chirp-manifest": "static-1.561",
  "chirp-fetch": "static-1.2386",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4956",
  "FormUrlGenerator": "static-2.5194",
  "sequences-lib": "static-1.8799",
  "apollo-link-hub-http": "static-2.5069",
  "FileManagerCore": "static-1.40359",
  "FileManagerLib": "static-1.40500",
  "hubspot-apollo-client": "static-1.5364",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.739",
  "timezone-utils": "static-2.5711",
  "ui-gdpr-components": "static-1.10656",
  "react-dnd-compat": "static-1.5091",
  "stylex-utils": "static-1.175",
  "trellis-theming": "static-1.1491",
  "react-flip-move": "static-1.83",
  "avatar-components": "static-1.2967",
  "hs-resources": "static-1.667",
  "pulse": "static-1.1129",
  "utility-belt": "static-1.3019",
  "zustand": "static-1.89",
  "batch-promise": "static-1.2030",
  "customer-data-associations": "static-1.7819",
  "customer-data-property-utils": "static-1.8532",
  "customer-data-tracking": "static-1.7352",
  "framework-data-schema-resolvers": "static-1.7374",
  "framework-data-table": "static-2.12852",
  "object-builder-ui-client": "static-1.50067",
  "payments-enrollment-embed-lib": "static-1.24222",
  "stripe-embedded-components": "static-1.8257",
  "ui-addon-opt": "static-4.8892",
  "ai-components-ui-library": "static-1.10036",
  "customer-data-rte": "static-1.33915",
  "cv-backend-services": "static-1.1607",
  "file-manager-components": "static-1.24860",
  "growth-onboarding-confetti": "static-1.3540",
  "growth-onboarding-empty-states": "static-1.6546",
  "hubspot-prosemirror": "static-1.19296",
  "InboxConnectUtils": "static-4.15857",
  "payment-link-components": "static-1.24471",
  "payments-post-enroll-local-storage-lib": "static-1.5586",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39187",
  "react-colorpicker": "static-2.10691",
  "ui-addon-upgrades": "static-9.18548",
  "ui-addon-video-player": "static-1.9105",
  "user-context": "static-1.5535",
  "restore-request-side-panel-lib": "static-1.2040",
  "atom": "static-1.5554",
  "reference-resolvers": "static-1.8665",
  "calling-global-api": "static-1.66217",
  "calling-internal-common": "static-1.31807",
  "calling-lifecycle-internal": "static-1.67599",
  "calling-lifecycle-messages": "static-1.59891",
  "commerce-products-lib": "static-1.10936",
  "conditional-properties-service-client": "static-1.4116",
  "crm-index-visualization-core": "static-1.4767",
  "crm-links": "static-1.6793",
  "crm-pipelines-api-client-types": "static-1.4446",
  "customer-data-properties-shared-msw-handlers": "static-1.10246",
  "external-options-client-types": "static-1.4442",
  "formula-editor": "static-1.15022",
  "google-libphonenumber": "static-1.49",
  "inbound-db-meta-service-client": "static-1.3777",
  "inbounddb-objects-service-types": "static-1.4521",
  "meetings-icalendar-utils-lib": "static-1.1113",
  "multi-currency-client-types": "static-1.4010",
  "pipeline-validation-client-types": "static-1.4285",
  "property-value-citations": "static-1.3685",
  "reference-resolvers-lite": "static-1.8594",
  "smart-data-capture-core": "static-1.490",
  "smart-property-lib": "static-1.8675",
  "tiered-pricing": "static-1.2294",
  "topics-actions-lib": "static-1.664",
  "trellis-ext-i18n": "static-1.1400",
  "trial-components-library": "static-1.14387",
  "ui-addon-form-validation": "static-1.11348",
  "laboratory-lib": "static-3.7628",
  "onboarding-scopes": "static-1.6934",
  "seat-types-lib": "static-1.1068",
  "magpie-lib": "static-1.5912",
  "navigation-messaging": "static-1.8510",
  "ts-schema": "static-1.4397",
  "opentelemetry-web": "static-1.23",
  "hub-http-shared-msw-handlers": "static-1.10919",
  "hubspotter-http-shared-msw-handlers": "static-1.10917",
  "base-ui": "static-1.28",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "amplitude-session-replay-browser": "static-1.60",
  "sequences-client-types-lib": "static-1.8656",
  "audio-components": "static-1.6583",
  "breeze-artifacts-sdk": "static-1.995",
  "ContentUtils": "static-1.69491",
  "copilot-toolkit": "static-1.12164",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30073",
  "FileManagerImages": "static-1.38011",
  "html-to-image": "static-1.65",
  "immerable": "static-1.4623",
  "ui-universal-auth": "static-1.9759",
  "urlinator": "static-1.4996",
  "video-components": "static-1.14450",
  "video-data-lib": "static-1.36106",
  "video-embed": "static-1.36940",
  "hubspot-apollo-cache": "static-1.823",
  "trellis-migration-context": "static-1.62",
  "event-emitter": "static-1.1443",
  "fdsr-migration-layer": "static-1.493",
  "framework-builder-read-service-client": "static-1.4338",
  "bend-plugin-pulse": "static-1.632",
  "fast-json-patch": "static-1.74",
  "framework-data-schema-quick-fetch": "static-1.7279",
  "persist-promise": "static-1.4187",
  "customer-data-reference-ui-components": "static-1.13657",
  "reporting-data": "static-1.69376",
  "tasks-actions-lib": "static-1.451",
  "purchase-motions-components": "static-1.6641",
  "growth-onboarding-feedback-components": "static-1.7062",
  "growth-onboarding-reliability": "static-1.5565",
  "marketplace-ui-apps-core": "static-1.19582",
  "onboarding-tours": "static-1.17410",
  "stripe-connect-js": "static-1.82",
  "chatspot-core": "static-1.23926",
  "content-assistance-lib": "static-1.8433",
  "draft-content-plugins": "static-1.29170",
  "draft-convert": "static-2.84",
  "draft-extend": "static-3.88",
  "draft-js": "static-5.90",
  "draft-plugins": "static-2.22369",
  "rich-text-lib": "static-1.20566",
  "breeze-engine-lib": "static-1.2214",
  "poll-commands": "static-1.3959",
  "video-components-external": "static-1.12448",
  "trellis-story-utils": "static-1.4980",
  "ui-addon-react-router-dom": "static-1.10006",
  "content-media-capture": "static-1.5814",
  "knowledge-content-types": "static-1.8763",
  "ui-addon-emoji-picker": "static-1.10345",
  "ui-business-units-lib": "static-1.9577",
  "ui-shepherd-react": "static-3.10760",
  "hub-http-contrib": "static-1.3514",
  "ui-addon-sales-email": "static-1.5683",
  "commerce-tours-lib": "static-1.6874",
  "getting-started-shared-tasks": "static-1.19580",
  "sales-checkout-service-client": "static-1.4001",
  "merchandise-lib": "static-1.286",
  "getting-started-shared-tasks-store": "static-1.18698",
  "onboarding-tours-utils": "static-1.1477",
  "calling-error-reporting": "static-1.31814",
  "shared-worker-versioning": "static-1.11523",
  "calling-usage-tracker": "static-1.7021",
  "conversations-skeleton-state": "static-1.7608",
  "voice-sms-access-library": "static-1.2477",
  "commerce-permissions": "static-1.1266",
  "products-iframe-lib": "static-1.8931",
  "products-ui-components-shared-msw-handlers": "static-1.11301",
  "crm-index-associations-lib": "static-1.6930",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11002",
  "sales-views-client-types": "static-1.4739",
  "location-customization-utils-lib": "static-1.10439",
  "bark-lib": "static-1.17013",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6377",
  "react-codemirror": "static-1.11123",
  "data-agent-kit": "static-1.930",
  "data-agent-test-utils": "static-1.474",
  "data-agent-utils": "static-1.943",
  "data-token-picker": "static-1.17146",
  "fsm": "static-1.4239",
  "markdown-it": "static-1.6",
  "policy-lib": "static-1.7286",
  "react-tinymce": "static-1.56284",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11065",
  "tinymce-config": "static-2.55410",
  "tinymce-plugins": "static-1.58524",
  "embedded-academy-lib": "static-1.16027",
  "hubs-service-types": "static-1.1750",
  "navigation-components": "static-1.19183",
  "nest": "static-1.717",
  "nudge-client-utils": "static-1.3433",
  "purchase-motions-api": "static-1.6644",
  "signup-constants": "static-1.19955",
  "idb-keyval": "static-1.55",
  "magpie-types": "static-1.5372",
  "reactive-lib": "static-1.1201",
  "simple-logging-lib": "static-1.3533",
  "nav-meta": "static-1.30820",
  "breeze-engine-core": "static-1.1492",
  "cms-field-types": "static-1.5292",
  "content-icons-ui": "static-1.2463",
  "integrations-lib": "static-1.17446",
  "underscore": "static-1.8",
  "custom-vendor-connection-lib": "static-1.323",
  "unified-auth-core-lib": "static-1.1555",
  "social-insights-client-types": "static-1.22946",
  "outpost": "static-1.4609",
  "reporting-client-types": "static-1.2842",
  "signup-ui-url-generator": "static-2.8520",
  "developer-experience-shared-components": "static-1.11021",
  "immutable-less": "static-1.5134",
  "marketplace-ui-client-types": "static-1.18457",
  "marketplace-ui-common": "static-1.21050",
  "ui-addon-integrations-directory-panel": "static-2.8435",
  "ui-extensibility-client-types": "static-1.4397",
  "growth-data-modal": "static-1.6145",
  "growth-onboarding-next-action-utils": "static-1.3000",
  "onboarding-tours-client": "static-1.5625",
  "ui-shepherd-tracker": "static-1.8141",
  "ui-coaching-tips": "static-1.29590",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1192",
  "highlight.js": "static-1.90",
  "content-media-composition-data-lib": "static-1.13618",
  "content-media-compositions": "static-2.17625",
  "media-bridge-lib": "static-1.19653",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4909",
  "calling-orchestration-schema": "static-1.37254",
  "crm-record-cards-service-types": "static-1.3871",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16684",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.115",
  "enrichment-settings-lib": "static-1.248",
  "storybook-react": "static-1.44",
  "tinymce": "static-5.11",
  "tinymce-themes": "static-1.57380",
  "interframe": "static-3.5223",
  "tinymce-data": "static-1.41495",
  "layout-dnd-components": "static-1.13240",
  "layout-dnd-utils": "static-1.12215",
  "ui-brand-identity-lib": "static-1.16968",
  "academy-common-lib": "static-1.15488",
  "nudge-custom-function-registry": "static-1.3190",
  "nudge-renderer-utils": "static-1.3509",
  "whisper-core-api": "static-1.7652",
  "flux-actions": "static-1.381",
  "integrations-error-boundary-lib": "static-1.14861",
  "integrations-tracking-lib": "static-1.6102",
  "redux-observable": "static-1.79",
  "rxjs": "static-5.10",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4619",
  "ai-settings-ui-library": "static-1.8603",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1595",
  "onboarding-data-sync-lib": "static-1.2851",
  "growth-onboarding-next-action-components": "static-1.3028",
  "user-context-client": "static-1.4991",
  "js-cookie": "static-1.18",
  "NamespacedHubStyle": "static-2.9370",
  "ContentData": "static-1.69566",
  "layout-data-lib": "static-1.10540",
  "academy-service-client": "static-1.4174",
  "croppie": "static-2.10",
  "final-form": "static-1.83",
  "SafeStorage": "static-1.4878",
  "trellis-ecosystem": "static-1.7861",
  "wootric-nps": "static-1.7299",
  "universal-page-editor-lib": "static-1.3494",
  "settings-ui-lib": "static-1.13009",
  "simple-data-table": "static-1.3837",
  "meetings-connect-utils-lib": "static-1.8100",
  "advanced-menus-core": "static-1.15827",
  "advanced-menus-lib": "static-1.12577",
  "ExportDialog": "static-6.10855",
  "ui-memberships-settings-lib": "static-1.35216",
  "crm-record-cards-client": "static-1.75",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15826",
  "simple-menus-lib": "static-1.17343"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28721",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.2025",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.511",
  "crm_data": "/crm_data/static-4.93224",
  "data-fetching-client": "/data-fetching-client/static-1.10122",
  "emoji-mart": "/emoji-mart/static-3.7",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8761",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1786",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6074",
  "hs-test-utils": "/hs-test-utils/static-1.8520",
  "hub-http": "/hub-http/static-1.6688",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11969",
  "I18n": "/I18n/static-7.1708",
  "jasmine-runner": "/jasmine-runner/static-1.6934",
  "quartz": "/quartz/static-1.7665",
  "raven": "/raven/static-3.5925",
  "react-dlb": "/react-dlb/static-1.94",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-stripe-js": "/react-stripe-js/static-1.120",
  "react-utils": "/react-utils/static-2.5659",
  "reselect": "/reselect/static-3.16",
  "stripe-js": "/stripe-js/static-1.119",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6106",
  "UIComponents": "/UIComponents/static-3.8915",
  "usage-tracker-public": "/usage-tracker-public/static-1.7617",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38071",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.644",
  "cssUtils": "/cssUtils/static-1.1104",
  "customer-data-objects": "/customer-data-objects/static-1.8187",
  "FireAlarmUi": "/FireAlarmUi/static-1.4871",
  "foundations-assets": "/foundations-assets/static-1.5368",
  "foundations-theming": "/foundations-theming/static-1.4970",
  "graphql": "/graphql/static-1.93",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12276",
  "icons": "/icons/static-2.703",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3366",
  "property-translator": "/property-translator/static-1.5861",
  "quartz-config": "/quartz-config/static-1.1443",
  "quartz-core": "/quartz-core/static-1.6884",
  "quartz-i18n": "/quartz-i18n/static-1.1340",
  "quartz-routing": "/quartz-routing/static-1.1095",
  "quartz-tracking": "/quartz-tracking/static-1.1044",
  "react": "/react/static-7.203",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17219",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-virtualized": "/react-virtualized/static-2.112",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.84",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "ReduxMessenger": "/ReduxMessenger/static-2.10852",
  "rpc-client-utils": "/rpc-client-utils/static-1.5151",
  "sanitize-text": "/sanitize-text/static-1.8640",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.188",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "superstore": "/superstore/static-1.5241",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11627",
  "ui-images": "/ui-images/static-2.1277",
  "usage-tracker-core": "/usage-tracker-core/static-1.7656",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3942",
  "quartz-webpack": "/quartz-webpack/static-1.3889",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.743",
  "bender-build-tools": "/bender-build-tools/static-1.3600",
  "crm_universal": "/crm_universal/static-1.22738",
  "customer-data-email": "/customer-data-email/static-1.18653",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10313",
  "dispatcher": "/dispatcher/static-1.147",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8402",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8245",
  "quick-fetch": "/quick-fetch/static-1.4234",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5030",
  "floating-ui": "/floating-ui/static-1.68",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2686",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-story-utils": "/hs-story-utils/static-1.9909",
  "react-aria": "/react-aria/static-1.77",
  "react-create-root-preference": "/react-create-root-preference/static-1.103",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3102",
  "ui-fonts": "/ui-fonts/static-1.1231",
  "HeadJS": "/HeadJS/static-2.822",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3631",
  "msw": "/msw/static-1.103",
  "msw-config": "/msw-config/static-1.29",
  "testing-library": "/testing-library/static-1.164",
  "hs-locale-management": "/hs-locale-management/static-1.403",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4789",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6244",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5230",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20509",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19581",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11336",
  "crm-message-bus": "/crm-message-bus/static-1.44127",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13517",
  "customer-data-properties": "/customer-data-properties/static-1.53071",
  "growth-payments-core": "/growth-payments-core/static-1.26520",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9557",
  "usage-tracker": "/usage-tracker/static-1.7806",
  "usage-tracker-container": "/usage-tracker-container/static-1.7796",
  "sassPrefix": "/sassPrefix/static-1.370",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4154",
  "foundations-theming-base": "/foundations-theming-base/static-1.3955",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3453",
  "stylex": "/stylex/static-1.46",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.273",
  "hub-http-janus": "/hub-http-janus/static-1.907",
  "hubspotter-http": "/hubspotter-http/static-1.4978",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.606",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.648",
  "quartz-auth": "/quartz-auth/static-1.1340",
  "quartz-head": "/quartz-head/static-1.1330",
  "quartz-test": "/quartz-test/static-1.1340",
  "trellis-components": "/trellis-components/static-1.3121",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5492",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.182",
  "web-vitals": "/web-vitals/static-1.19",
  "immer": "/immer/static-1.105",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.561",
  "chirp-fetch": "/chirp-fetch/static-1.2386",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4956",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5194",
  "sequences-lib": "/sequences-lib/static-1.8799",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5069",
  "FileManagerCore": "/FileManagerCore/static-1.40359",
  "FileManagerLib": "/FileManagerLib/static-1.40500",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5364",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.739",
  "timezone-utils": "/timezone-utils/static-2.5711",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10656",
  "react-dnd-compat": "/react-dnd-compat/static-1.5091",
  "stylex-utils": "/stylex-utils/static-1.175",
  "trellis-theming": "/trellis-theming/static-1.1491",
  "react-flip-move": "/react-flip-move/static-1.83",
  "avatar-components": "/avatar-components/static-1.2967",
  "hs-resources": "/hs-resources/static-1.667",
  "pulse": "/pulse/static-1.1129",
  "utility-belt": "/utility-belt/static-1.3019",
  "zustand": "/zustand/static-1.89",
  "batch-promise": "/batch-promise/static-1.2030",
  "customer-data-associations": "/customer-data-associations/static-1.7819",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8532",
  "customer-data-tracking": "/customer-data-tracking/static-1.7352",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7374",
  "framework-data-table": "/framework-data-table/static-2.12852",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50067",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24222",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8257",
  "ui-addon-opt": "/ui-addon-opt/static-4.8892",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10036",
  "customer-data-rte": "/customer-data-rte/static-1.33915",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "file-manager-components": "/file-manager-components/static-1.24860",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3540",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6546",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19296",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15857",
  "payment-link-components": "/payment-link-components/static-1.24471",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5586",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39187",
  "react-colorpicker": "/react-colorpicker/static-2.10691",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18548",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9105",
  "user-context": "/user-context/static-1.5535",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2040",
  "atom": "/atom/static-1.5554",
  "reference-resolvers": "/reference-resolvers/static-1.8665",
  "calling-global-api": "/calling-global-api/static-1.66217",
  "calling-internal-common": "/calling-internal-common/static-1.31807",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67599",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59891",
  "commerce-products-lib": "/commerce-products-lib/static-1.10936",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4116",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4767",
  "crm-links": "/crm-links/static-1.6793",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4446",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10246",
  "external-options-client-types": "/external-options-client-types/static-1.4442",
  "formula-editor": "/formula-editor/static-1.15022",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3777",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4521",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1113",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4010",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4285",
  "property-value-citations": "/property-value-citations/static-1.3685",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8594",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.490",
  "smart-property-lib": "/smart-property-lib/static-1.8675",
  "tiered-pricing": "/tiered-pricing/static-1.2294",
  "topics-actions-lib": "/topics-actions-lib/static-1.664",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1400",
  "trial-components-library": "/trial-components-library/static-1.14387",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11348",
  "laboratory-lib": "/laboratory-lib/static-3.7628",
  "onboarding-scopes": "/onboarding-scopes/static-1.6934",
  "seat-types-lib": "/seat-types-lib/static-1.1068",
  "magpie-lib": "/magpie-lib/static-1.5912",
  "navigation-messaging": "/navigation-messaging/static-1.8510",
  "ts-schema": "/ts-schema/static-1.4397",
  "opentelemetry-web": "/opentelemetry-web/static-1.23",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10919",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10917",
  "base-ui": "/base-ui/static-1.28",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8656",
  "audio-components": "/audio-components/static-1.6583",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.995",
  "ContentUtils": "/ContentUtils/static-1.69491",
  "copilot-toolkit": "/copilot-toolkit/static-1.12164",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30073",
  "FileManagerImages": "/FileManagerImages/static-1.38011",
  "html-to-image": "/html-to-image/static-1.65",
  "immerable": "/immerable/static-1.4623",
  "ui-universal-auth": "/ui-universal-auth/static-1.9759",
  "urlinator": "/urlinator/static-1.4996",
  "video-components": "/video-components/static-1.14450",
  "video-data-lib": "/video-data-lib/static-1.36106",
  "video-embed": "/video-embed/static-1.36940",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.823",
  "trellis-migration-context": "/trellis-migration-context/static-1.62",
  "event-emitter": "/event-emitter/static-1.1443",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.493",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4338",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.632",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7279",
  "persist-promise": "/persist-promise/static-1.4187",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13657",
  "reporting-data": "/reporting-data/static-1.69376",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.451",
  "purchase-motions-components": "/purchase-motions-components/static-1.6641",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7062",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5565",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19582",
  "onboarding-tours": "/onboarding-tours/static-1.17410",
  "stripe-connect-js": "/stripe-connect-js/static-1.82",
  "chatspot-core": "/chatspot-core/static-1.23926",
  "content-assistance-lib": "/content-assistance-lib/static-1.8433",
  "draft-content-plugins": "/draft-content-plugins/static-1.29170",
  "draft-convert": "/draft-convert/static-2.84",
  "draft-extend": "/draft-extend/static-3.88",
  "draft-js": "/draft-js/static-5.90",
  "draft-plugins": "/draft-plugins/static-2.22369",
  "rich-text-lib": "/rich-text-lib/static-1.20566",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2214",
  "poll-commands": "/poll-commands/static-1.3959",
  "video-components-external": "/video-components-external/static-1.12448",
  "trellis-story-utils": "/trellis-story-utils/static-1.4980",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10006",
  "content-media-capture": "/content-media-capture/static-1.5814",
  "knowledge-content-types": "/knowledge-content-types/static-1.8763",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10345",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9577",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10760",
  "hub-http-contrib": "/hub-http-contrib/static-1.3514",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5683",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6874",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19580",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4001",
  "merchandise-lib": "/merchandise-lib/static-1.286",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18698",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1477",
  "calling-error-reporting": "/calling-error-reporting/static-1.31814",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11523",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7021",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7608",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2477",
  "commerce-permissions": "/commerce-permissions/static-1.1266",
  "products-iframe-lib": "/products-iframe-lib/static-1.8931",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11301",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6930",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11002",
  "sales-views-client-types": "/sales-views-client-types/static-1.4739",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10439",
  "bark-lib": "/bark-lib/static-1.17013",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6377",
  "react-codemirror": "/react-codemirror/static-1.11123",
  "data-agent-kit": "/data-agent-kit/static-1.930",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.474",
  "data-agent-utils": "/data-agent-utils/static-1.943",
  "data-token-picker": "/data-token-picker/static-1.17146",
  "fsm": "/fsm/static-1.4239",
  "markdown-it": "/markdown-it/static-1.6",
  "policy-lib": "/policy-lib/static-1.7286",
  "react-tinymce": "/react-tinymce/static-1.56284",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11065",
  "tinymce-config": "/tinymce-config/static-2.55410",
  "tinymce-plugins": "/tinymce-plugins/static-1.58524",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16027",
  "hubs-service-types": "/hubs-service-types/static-1.1750",
  "navigation-components": "/navigation-components/static-1.19183",
  "nest": "/nest/static-1.717",
  "nudge-client-utils": "/nudge-client-utils/static-1.3433",
  "purchase-motions-api": "/purchase-motions-api/static-1.6644",
  "signup-constants": "/signup-constants/static-1.19955",
  "idb-keyval": "/idb-keyval/static-1.55",
  "magpie-types": "/magpie-types/static-1.5372",
  "reactive-lib": "/reactive-lib/static-1.1201",
  "simple-logging-lib": "/simple-logging-lib/static-1.3533",
  "nav-meta": "/nav-meta/static-1.30820",
  "breeze-engine-core": "/breeze-engine-core/static-1.1492",
  "cms-field-types": "/cms-field-types/static-1.5292",
  "content-icons-ui": "/content-icons-ui/static-1.2463",
  "integrations-lib": "/integrations-lib/static-1.17446",
  "underscore": "/underscore/static-1.8",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.323",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1555",
  "social-insights-client-types": "/social-insights-client-types/static-1.22946",
  "outpost": "/outpost/static-1.4609",
  "reporting-client-types": "/reporting-client-types/static-1.2842",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8520",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11021",
  "immutable-less": "/immutable-less/static-1.5134",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18457",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21050",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8435",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4397",
  "growth-data-modal": "/growth-data-modal/static-1.6145",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3000",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5625",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8141",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29590",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1192",
  "highlight.js": "/highlight.js/static-1.90",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13618",
  "content-media-compositions": "/content-media-compositions/static-2.17625",
  "media-bridge-lib": "/media-bridge-lib/static-1.19653",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4909",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37254",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16684",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.115",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.248",
  "storybook-react": "/storybook-react/static-1.44",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-themes": "/tinymce-themes/static-1.57380",
  "interframe": "/interframe/static-3.5223",
  "tinymce-data": "/tinymce-data/static-1.41495",
  "layout-dnd-components": "/layout-dnd-components/static-1.13240",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12215",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16968",
  "academy-common-lib": "/academy-common-lib/static-1.15488",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3190",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3509",
  "whisper-core-api": "/whisper-core-api/static-1.7652",
  "flux-actions": "/flux-actions/static-1.381",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14861",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6102",
  "redux-observable": "/redux-observable/static-1.79",
  "rxjs": "/rxjs/static-5.10",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4619",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8603",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1595",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2851",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3028",
  "user-context-client": "/user-context-client/static-1.4991",
  "js-cookie": "/js-cookie/static-1.18",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9370",
  "ContentData": "/ContentData/static-1.69566",
  "layout-data-lib": "/layout-data-lib/static-1.10540",
  "academy-service-client": "/academy-service-client/static-1.4174",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.83",
  "SafeStorage": "/SafeStorage/static-1.4878",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7861",
  "wootric-nps": "/wootric-nps/static-1.7299",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3494",
  "settings-ui-lib": "/settings-ui-lib/static-1.13009",
  "simple-data-table": "/simple-data-table/static-1.3837",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8100",
  "advanced-menus-core": "/advanced-menus-core/static-1.15827",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12577",
  "ExportDialog": "/ExportDialog/static-6.10855",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35216",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.75",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15826",
  "simple-menus-lib": "/simple-menus-lib/static-1.17343"
}
};
